import config from '../config/app.config'
/* ==========================================================================
  LANGUAGES
  ========================================================================== */
export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'Chinese', languageCode: 'zh' },
  { label: 'German', languageCode: 'de' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' },
  { label: 'Korean', languageCode: 'ko' }
]

export const LANGUAGE_CODES = ['en', 'es', 'zh', 'de', 'fr', 'pt', 'ru', 'ko']

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = Object.freeze({
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
})

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'authtoken'
export const LANGUAGE = 'operator_language'
export const WALLET_SETTING = 'operator_walletSetting'
export const CHAT = 'chat'
export const LIVE_DATA = 'liveData'
export const SHOW_SIDE_NAV = 'showSideNav'
export const PROVIDER_ID = 'providerId'
export const ANNOUNCEMENTS = 'announcements'
export const LANGUAGE_ROOM_ID = 'languageRoomId'
export const CHAT_GROUP_ID = 'chatGroupId'

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
export const TOASTER_TYPE = Object.freeze({
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
})

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = Object.freeze({
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader',
  content: 'contentLoader',
  liveWins: 'liveWins',
  gameBarFavourites: 'gameBarFavourites',
  categoryWiseGamesList: 'categoryWiseGamesList',
  userDetails: 'userDetails',
  walletAddress: 'walletAddress',
  chat: 'chat'
})

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = Object.freeze({
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  VERIFY_EMAIL: '/verify/:userId/:verificationToken',
  RESET_PASSWORD: '/reset-password/:userId/:resetToken',
  ABOUT: '/about',
  INFO: '/site-info',
  SITE_INFO: '/site-info/:pageName',
  TERMS_AND_CONDITION: '/terms-condition',
  PROMOTIONS: '/promotions',
  PROMOTION_DETAILS: '/promotions/:promotionId',
  PROFILE: '/account/profile',
  BALANCE: '/account/balances',
  DEPOSIT: '/account/deposits',
  WITHDRAWALS: '/account/withdrawals',
  // REFERRALS: '/account/referrals',
  SETTINGS: '/account/settings',
  TRANSACTIONS: '/account/transactions',
  REWARDS: '/rewards',
  ACCOUNT_VERIFICATION: '/verify-account',
  // LIMITS: '/account/limits',
  PRE_LOGIN_REWARDS: '/rewards-users',
  PRE_LOGIN_AFFILIATES: '/affiliates/users',
  predictionMarket: '/prediction-market',
  predictionMarketMarkets: '/prediction-market/markets',
  predictionMarketMarketDetail: '/prediction-market/market-detail',
  predictionMarketPortfolio: '/prediction-market/portfolio',
  predictionMarketTerms: '/prediction-market/terms-and-conditions',
  predictionMarketPrivacy: '/prediction-market/privacy-policy',
  predictionMarketAmlKyc: '/prediction-market/aml-kyc-policy'
})

/* ==========================================================================
  Table Cell Type
========================================================================== */
export const TABLE_CELL_TYPE = Object.freeze({
  status: 'status',
  switch: 'switch',
  button: 'button',
  date: 'date',
  text: 'text',
  number: 'number',
  default: 'default',
  updateIconButton: 'updateIconButton',
  deleteIconButton: 'deleteIconButton',
  actionCell: 'actionCell',
  object: 'object'
})

/* ==========================================================================
  Bet Result constants
========================================================================== */
export const BET_RESULT = Object.freeze({
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
})

export const DEFAULT_LIVE_STATS = { profit: 0, wins: 0, wagered: 0, losses: 0 }

/* ==========================================================================
  Table transactions tabs constants
========================================================================== */
export const TRANSACTION_TABS = Object.freeze({
  ALL_BETS: 'all-bets',
  HIGH_ROLLER: 'high-roller'
})

/* ==========================================================================
  Bonus status constants
========================================================================== */
export const BONUS_STATUS = Object.freeze({
  ACTIVE: 'active',
  CLAIMED: 'claimed',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  FORFEIT: 'forfeit',
  READY_TO_CLAIM: 'readyToClaim'
})

/* ==========================================================================
  Provable Fair Text
========================================================================== */
export const PROVABLE_FAIR_TEXT = '"Provably fair" is a term that refers to a system or algorithm used in online gambling or gaming that can be mathematically verified to ensure that the results are fair and not manipulated in any way. It is a way for players to know that the game or gambling platform they are using is legitimate and not rigged against them.'

/* ==========================================================================
  Transaction status and type constants
========================================================================== */
export const TRANSACTIONS_STATUS = Object.freeze({
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILED: 'failed'
})

export const TRANSACTIONS_TYPE = Object.freeze({
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  ORIGINALS: 'ORIGINALS',
  RECEIVE: 'receive',
  BONUS: 'bonus',
  MOONPAY: 'moonpay'
})

export const PAYMENT_METHOD = Object.freeze({
  TIPPING: 'tipping'
})

export const LIVE_WINS_TABS = Object.freeze({
  LIVE_WINS: 'live-wins',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day'
})

export const LIVE_WINS_TYPES = {
  CASINO_WIN: 'casino-win',
  CASINO_BET: 'casino-bet'
}

/* ==========================================================================
  Other constants
========================================================================== */
export const DEFAULT_PAGE_CALLS = 10
export const DEFAULT_PRECISION = 5
export const DEFAULT_PRECISION_MONEY = 8
export const PAGINATION_LIMIT = 10
export const PAGINATION_LIMIT_FOR_ALLBETS = 10
export const DEFAULT_AUTO_BET_COUNTER = 3
export const MIN_WITHDRAW_AMOUNT = 0.003
export const WITHDRAW_FEES = 0.000006
export const TAB_SELECTION = Object.freeze({
  placed: Symbol('placed'),
  previous: Symbol('previous')
})
export const ROLLOVER = 'rollOver'
export const STRATEGY = 'strategiesSaved'
export const USER_DISCLAIMER = 'userDisclaimer'
export const LIVE_WINS_RECORDS_LIMIT = 10
export const MAX_MESSAGE_CHARACTERS_LIMIT = 200

// ==============================================================
// Bet Transaction Types
// ==============================================================
export const transactionType = {
  PUBLIC_BETS: 'publicBets',
  LEADERBOARD: 'leaderboard',
  ACTIVE_BETS: 'activeBets',
  CLOSED_BETS: 'closedBets'
}

// =======================================================================================
export const perArr = [-100, -50, -10, -5, -1, -0.5, -0.10, -0.05, -0.01, 0, 0.01, 0.05, 0.10, 0.48, 0.95, 4.75, 9.50, 47.50, 95, 475, 950]
// =======================================================================================

/* ==========================================================================
  Login Method Types
========================================================================== */
export const LOGIN_METHODS = Object.freeze({
  GOOGLE: 'google',
  TWITCH: 'twitch',
  METAMASK: 'metamask',
  PHANTOM: 'phantom'
})
/* =====================================================================
  Cryptocoin-id
======================================================================== */
export const CRYPTO_NAME = {
  1: 'Bitcoin',
  2: 'Ethereum',
  3: 'Dogecoin',
  4: 'Litecoin'
}

export const CRYPTO_COIN = {
  BITCOIN: 'Bitcoin',
  ETHEREUM: 'Ethereum',
  DOGECOIN: 'Dogecoin',
  LITECOIN: 'Litecoin'
}

export const CRYPTO_COINS = Object.freeze({
  // 'USDC.TRC20': 'USDC',
  'BNB.BSC': 'BNB',
  'MATIC.POLY': 'MATIC',
  USDT_ERC20: 'USDT',
  'USDT.TRC20': 'USDT',
  'USDT.BEP20': 'USDT',
  'USDT.POL': 'USDT',
  'USDC.ERC20': 'USDC',
  XRP: 'XRP',
  TRX: 'TRX',
  BTC_TEST: 'BTC',
  ETH_TEST5: 'ETH',
  SOL_TEST: 'SOL',
  LTC_TEST: 'LTC',
  USD: 'USD',
  LTCT: 'LTC',
  LTC: 'LTC',
  BTC: 'BTC',
  ETH: 'ETH',
  SOL: 'SOL',
  EUR: 'EUR',
  DOGE: 'DOGE'
})

export const FIAT_CURRENCY = [
  {
    id: '1',
    code: 'EUR',
    img: `${config.S3_PATH}/unnamed_d261de0d-8c6e-4618-8110-0949a0e599af.png`,
    symbol: '€'
  },
  {
    id: '3',
    code: 'USD',
    img: `${config.S3_PATH}/usdc_4897a2ec-a1a2-4638-ae0b-0f93750097c2.png`,
    symbol: '$'
  }
]

export const LIMIT_TYPE = {
  WAGER: 'wager',
  LOSS: 'loss',
  DEPOSIT: 'deposit',
  SESSION: 'session',
  TAKE_A_BREAK: 'TAKE_A_BREAK',
  SELF_EXCLUSION: 'SELF_EXCLUSION'
}
export const TOOLTIP_VARIANT = Object.freeze({
  SIDE_BAR: 'sidebar',
  SIDEBAR_BUTTON: 'sidebarButton',
  DEFAULT: 'default'
})

export const SOCIAL_ACCOUNTS = Object.freeze({
  TWITCH: 'twitch',
  TWITTER: 'twitter',
  STEAM: 'steam'
})

export const KYC_LEVELS = Object.freeze({
  CUSTOM_LEVEL: 'systemLevel',
  DIDIT: 'didit',
  BASIC_KYC: 'basic-kyc',
  LIVENESS: 'liveness',
  ADDRESS_PROOF: 'proof-of-address',
  SOF: 'source-of-funds'
})

export const KYC_LEVELS_ORDER = [
  KYC_LEVELS.DIDIT
]

export const SYSTEM_KYC_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  RE_REQUESTED: 're-requested',
  INIT: 'init',
  COMPLETED: 'completed',
  ON_HOLD: 'onHold'
})

export const ACCORDION_BUTTON_COLOR = Object.freeze({
  WHITE: 'white',
  GREY: 'grey'
})

export const SOCIAL_LINKS = {
  [SOCIAL_ACCOUNTS.TWITTER]: 'https://twitter.com/',
  [SOCIAL_ACCOUNTS.TWITCH]: 'https://www.twitch.tv/',
  [SOCIAL_ACCOUNTS.STEAM]: ''
}

export const S3_IMAGES_URL = Object.freeze({
  IMAGE_URL: config.S3_PATH
})

export const BONUS_TYPES = Object.freeze({
  CASHBACK: 'cashback',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  REFERRAL: 'referral',
  OTHER: 'other',
  WEEKLYSPLITTED: 'weeklysplitted',
  DEPOSIT: 'deposit',
  REGISTRATION: 'registration'
})

export const CRYPTO_SM_PRICE = ['3', '6', '9', '10', '14', '17', '24', '28', '30']

export const SORT_BY_OPTIONS = { Popular: '', Alphabetical: 'ASC', 'Alphabetical Z-A': 'DESC' }

export const WAGERING_STATUS = Object.freeze({
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  COMPLETE: 'COMPLETE'
})
